'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdThumbsUpDown = function MdThumbsUpDown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.5 16.6q1.1 0 1.8 0.8t0.7 1.7v10.9q0 1.1-0.7 1.8l-8.3 8.2-1.3-1.3q-0.6-0.6-0.6-1.4 0.3-1 0.7-3.1t0.5-2.6h-8.7q-0.7 0-1.1-0.4t-0.5-1.2v-2.1q0-0.2 0.2-0.9l3.8-8.8q0.7-1.6 2.3-1.6h11.2z m-17.5-6.6v2.1q0 0.2-0.2 0.9l-3.8 8.8q-0.7 1.6-2.2 1.6h-11.3q-1.1 0-1.8-0.8t-0.7-1.7v-10.9q0-1.1 0.7-1.8l8.3-8.2 1.3 1.3q0.6 0.6 0.6 1.4-0.3 1.1-0.7 3.1t-0.5 2.6h8.7q0.7 0 1.1 0.4t0.5 1.2z' })
        )
    );
};

exports.default = MdThumbsUpDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/thumbs-up-down.js
// module id = 1540
// module chunks = 36573943044255 79611799117203 213534597649335